module.exports = __webpack_public_path__ + "img/_ico.34c543a4.svg";